import { faker } from '@faker-js/faker';

import type { SubscriptionFormPostResponse } from '../types/SubscriptionFormPostResponse';

export function createSubscriptionFormPostResponse(
  data: NonNullable<Partial<SubscriptionFormPostResponse>> = {}
): NonNullable<SubscriptionFormPostResponse> {
  return {
    ...{
      data: {},
      response: {
        date: faker.string.alpha(),
        messages: faker.helpers.arrayElements([faker.string.alpha()]) as any,
        status: faker.number.int(),
        type: faker.string.alpha(),
      },
    },
    ...data,
  };
}
